export default __webpack_public_path__ + "static/nfts-illustration-dark-4161ce0391d758b16a1e77a8fa7c933a.svg";